import { render, staticRenderFns } from "./TagFilter.vue?vue&type=template&id=10c7d002&scoped=true&"
import script from "./TagFilter.vue?vue&type=script&lang=ts&"
export * from "./TagFilter.vue?vue&type=script&lang=ts&"
import style0 from "./TagFilter.vue?vue&type=style&index=0&id=10c7d002&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c7d002",
  null
  
)

export default component.exports